import HTMLEmptyModal from "../HTMLModalComponent/HTMLEmptyModal"
import styles from "./modals.module.scss"
import Image from "next/image"
import SText from "../Text/SText"
import classNames from "classnames"
import Link from "next/link"

const StudyParticipationModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  return (
    <HTMLEmptyModal
      isOpened={isOpen}
      onClose={closeModal}
      onProceed={() => null}
      innerModalCSS={classNames(styles.studyModal, styles.maskedOverflow)}
      outerModalCSS={styles.studyModalOuter}
    >
      <div className={styles.imageGridContainer}>
        <Image
          width={327}
          height={280}
          src={"/images/modal/studienteilnahme_img.webp"}
          alt={"studienteilnahme bild"}
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "100%",
          }}
        />
      </div>
      <div className={styles.containerLeft}>
        <div className={styles.headerTextContainer}>
          <SText variant={"body"} color={"green400"} size={14}>
            Im Rahmen unserer klinischen Zulassungsstudie können 30 Betroffene unsere Lösung für je 7 Wochen kostenfrei
            von Zuhause aus testen. Die ärztliche Begleitung erfolgt hierbei durch eines unserer drei Studienzentren:
          </SText>
        </div>
        <div className={styles.studyCentersContainer}>
          {/* <div className={classNames(styles.studyCenter, styles.greifswald)}>
            <SText
              variant={"title"}
              size={16}
              style={{
                display: "block",
                marginBottom: "8px",
              }}
            >
              Hautzentrum Greifswald
            </SText>
            <SText variant={"body"} color={"green400"} size={12} style={{ lineHeight: "100%" }}>
              03834 50 72 63
              <br />
              post@hautzentrum-greifswald.de
              <br />
              <Link href={"www.hautzentrum-greifswald.de"}>
                <SText variant={"body"} size={12} color={"turq400"}>
                  www.hautzentrum-greifswald.de
                </SText>
              </Link>
            </SText>
          </div> */}
          <div className={classNames(styles.studyCenter, styles.hamburg)}>
            <SText
              variant={"title"}
              size={16}
              style={{
                display: "block",
                marginBottom: "8px",
              }}
            >
              UKE Hamburg
            </SText>
            <SText variant={"body"} color={"green400"} style={{ lineHeight: "100%" }} size={12}>
              040 7410 - 58665
              <br />
              <Link
                href={
                  "https://www.uke.de/kliniken-institute/institute/versorgungsforschung-in-der-dermatologie-und-bei-pflegeberufen/index.html"
                }
              >
                <SText size={12} variant={"body"} color={"turq400"}>
                  UKE Studienwebseite
                </SText>
              </Link>
            </SText>
          </div>
        </div>
        <div className={styles.studyInformation}>
          <SText variant={"body"} color={"green400"} size={14}>
            Vereinbaren Sie gerne einen Termin unter dem Stichwort ‘SKINUVITA1 Studie’ Bitte bedenken Sie hierbei, dass
            die folgenden Kriterien für eine Teilnahme wichtig sind:
            <ul
              style={{
                paddingInlineStart: "20px",
                marginBlockStart: "0.5em",
              }}
            >
              <li>Mit Phototherapie behandelbare Hauterkrankung (z.B. Schuppenflechte, Neurodermitis, Handekzem)</li>
              <li>Aktueller Therapiebedarf für eine Teilkörperbestrahlung</li>
              <li>Smartphone mit Internetanschluss</li>
              <li>Zeitlich verfügbar für 7 Wochen Nutzungsdauer</li>
            </ul>
          </SText>
        </div>
      </div>
    </HTMLEmptyModal>
  )
}

export default StudyParticipationModal
